
import {mapState} from 'vuex';
import {find} from 'lodash';
import {jump} from '@utils'
import {enterInfo} from '@mixins'
import TopBar from '@components/topBar'
import FootBar from '@components/footBar'
import WrapManage from '@components/wrapManage'
const {WrapContent,ToBind,BtnList} = WrapManage

const components = {TopBar,WrapManage,WrapContent,ToBind,BtnList,FootBar}

const iconList = {
    auditing: require('@assets/images/enterManage/auditing.svg'),
    noPartner:require('@assets/images/enterManage/no_partner.svg'),
    refuse:require('@assets/images/enterManage/refuse.svg'),
    success:require('@assets/images/success.svg'),
}

export default {
    mixins:[enterInfo],
    components,
    data(){
        return {
            iconList,
            cms: {}
        }
    },
    beforeCreate(){
        this.$store.dispatch('getUserInfo')
    },
    created() {
        this.getCms();
    },
    methods:{
        async getCms(){
            this.cms = await this.$store.dispatch('pages/home/getCmsHome');
            return this.cms;
        },
        nowEnter(){
            // this.$store.commit('pages/home/scrollToId','#ENTER');
            jump.toEnter()
        },
        //继续入驻
        async goOnEnter(){
            if(!this.cms) {
                await this.getCms();
            }
            const bt = this.userInfo.settleInType || this.userInfo.buzzType
            const item = find(this.cms.enterData.settled_list,o => o.purpose == bt);
            if(item) {
                // location.href = item.url
                jump.goOnEnter(item.purpose, item)
            }
        },
        workbench(){
            //jump.workbench();
            jump.logout('workbench');
        },
        search(){
            jump.enterProgress()
        }
    },
    computed:{
        ...mapState(['userInfo'])
    }
}
